import { useState, useEffect } from 'react';
import api from '../../lib/api';
import { Card, CardContent } from '../../components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table';
import { Input } from '../../components/ui/input';
import { PawPrint, Search } from 'lucide-react';

export default function AdminPets() {
  const [pets, setPets] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/admin/pets').then(r => { setPets(r.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  const filtered = pets.filter(p =>
    p.name?.toLowerCase().includes(search.toLowerCase()) ||
    p.breed?.toLowerCase().includes(search.toLowerCase()) ||
    p.owner_name?.toLowerCase().includes(search.toLowerCase())
  );

  if (loading) return <div className="flex justify-center py-20"><div className="animate-spin rounded-full h-8 w-8 border-2 border-[#2D2D2D] border-t-transparent" /></div>;

  return (
    <div className="space-y-6" data-testid="admin-pets-page">
      <div className="flex items-center justify-between flex-wrap gap-4">
        <div>
          <h1 className="text-2xl md:text-3xl font-bold text-[#1A1A1A]" style={{ fontFamily: 'Manrope' }}>Pet Database</h1>
          <p className="text-sm text-[#5A5A5A] mt-1">{pets.length} pets</p>
        </div>
        <div className="relative w-64">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#888]" />
          <Input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search pets..." className="pl-10 rounded-lg" data-testid="pet-search-input" />
        </div>
      </div>

      <Card className="rounded-2xl border-[#E5E5E0] bg-white overflow-hidden" style={{ boxShadow: 'var(--shadow-soft)' }}>
        {filtered.length === 0 ? (
          <CardContent className="p-8 text-center"><PawPrint className="w-10 h-10 text-[#D6D6D0] mx-auto mb-3" /><p className="text-sm text-[#5A5A5A]">No pets found</p></CardContent>
        ) : (
          <div className="overflow-x-auto">
            <Table>
              <TableHeader>
                <TableRow className="bg-[#F9F9F7]">
                  <TableHead className="text-xs font-semibold text-[#5A5A5A]">Name</TableHead>
                  <TableHead className="text-xs font-semibold text-[#5A5A5A]">Species</TableHead>
                  <TableHead className="text-xs font-semibold text-[#5A5A5A]">Breed</TableHead>
                  <TableHead className="text-xs font-semibold text-[#5A5A5A]">Gender</TableHead>
                  <TableHead className="text-xs font-semibold text-[#5A5A5A]">Weight</TableHead>
                  <TableHead className="text-xs font-semibold text-[#5A5A5A]">Owner</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {filtered.map(p => (
                  <TableRow key={p.pet_id} data-testid={`pet-row-${p.pet_id}`}>
                    <TableCell className="text-sm font-medium">
                      <div className="flex items-center gap-2">
                        <div className="w-8 h-8 bg-[#F5F5F0] rounded-lg flex items-center justify-center"><PawPrint className="w-4 h-4 text-[#2D2D2D]" /></div>
                        {p.name}
                      </div>
                    </TableCell>
                    <TableCell className="text-sm capitalize">{p.species}</TableCell>
                    <TableCell className="text-sm">{p.breed || '-'}</TableCell>
                    <TableCell className="text-sm">{p.gender || '-'}</TableCell>
                    <TableCell className="text-sm">{p.weight ? `${p.weight} kg` : '-'}</TableCell>
                    <TableCell className="text-sm text-[#5A5A5A]">{p.owner_name}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        )}
      </Card>
    </div>
  );
}
